import { urls } from "common/urls";
import { ListElement } from "domain/admin/common/AdministrationList";

export enum LinkType {
  ADMIN = "ADMIN",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export function urlByType(
  type:
    | "StudyProgramme"
    | "ExamSyllabus"
    | "Folder"
    | "Kurssloeyfe"
    | "Article"
    | "MultipleChoice",
  id: string,
  isAdmin: boolean,
  isSyllabus?: boolean | any,
  isAdminPage?: boolean,
  isSyllabusInContext?: boolean,
): string {
  switch (type) {
    case "StudyProgramme":
      return isAdmin
        ? isSyllabus
          ? urls.studyProgrammeAdminExams(id)
          : urls.studyProgrammeAdmin(id)
        : urls.studyProgramme(id);
    case "ExamSyllabus":
      return isAdmin ? urls.examAdmin(id) : urls.exam(id);
    case "Folder":
      return isAdmin ? urls.folderAdmin(id) : urls.folder(id);
    case "Kurssloeyfe":
      return isAdmin ? urls.kurssloeyfeAdmin(id) : urls.kurssloeyfe(id);
    case "Article":
      return isAdmin ? urls.articleAdmin(id) : urls.article(id);
    case "MultipleChoice":
      return isAdmin ? urls.assignmentAdmin(id) : urls.question(id);
  }
}

export function kurssloeyfeUrlByType(
  type:
    | "StudyProgramme"
    | "ExamSyllabus"
    | "Folder"
    | "Kurssloeyfe"
    | "Article"
    | "MultipleChoice",
  elementId: string,
  kurssloeyfeId: string,
): string {
  switch (type) {
    case "Article":
      return urls.kurssloeyfeArticle(elementId, kurssloeyfeId);
    case "MultipleChoice":
      return urls.kurssloeyfeQuestion(elementId, kurssloeyfeId);
    default:
      throw new Error(
        `Tried to get create the url of an element inside kurssloeyfe with type ${type}, which is not allowed.`,
      );
  }
}

export function selfAssessmentUrlByType(
  type:
    | "StudyProgramme"
    | "ExamSyllabus"
    | "Folder"
    | "Kurssloeyfe"
    | "Article"
    | "MultipleChoice",
  elementId: string,
  selfAssessmentId: string,
): string {
  switch (type) {
    case "Article":
      return urls.selfAssessmentArticle(elementId, selfAssessmentId);
    case "MultipleChoice":
      return urls.selfAssessmentQuestion(elementId, selfAssessmentId);
    default:
      throw new Error(
        `Tried to get create the url of an element inside kurssloeyfe with type ${type}, which is not allowed.`,
      );
  }
}

export function urlForAdminPagesByCategory(
  element: ListElement,
  linkType: LinkType,
): string {
  switch (element.category) {
    case "KurssloeyfeElement":
      if (element.type === "Article") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.articleAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.articleAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.kurssloeyfeArticle(
              element.contentId,
              element.kurssloeyfeId,
            );
        }
      } else if (element.type === "MultipleChoice") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.assignmentAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.assignmentAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.kurssloeyfeQuestion(
              element.contentId,
              element.kurssloeyfeId,
            );
        }
      }
      throw Error("Found illegal type of element inside kurssløyfe");
    case "FolderElement":
      if (element.type === "Folder") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.folderAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.folderAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.folder(element.contentId);
        }
      } else if (element.type === "SelfAssessment") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.folderAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.folderAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.folder(element.contentId);
        }
      } else if (element.type === "Article") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.articleAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.articleAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.article(element.contentId);
        }
      } else if (element.type === "Kurssloeyfe") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.kurssloeyfeAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.kurssloeyfeAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.kurssloeyfe(element.contentId);
        }
      } else if (element.type === "MultipleChoice") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.assignmentAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.assignmentAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.question(element.contentId);
        }
      } else {
        throw Error("Found illegal type of element inside Folder");
      }
    case "Folder":
    case "ExamSyllabusElement":
    case "SelfAssessmentsContainer":
    case "SelfAssessment":
      //case "SimulationCaseElement":
      switch (linkType) {
        case LinkType.EDIT:
          return urls.folderAdminEdit(element.contentId);
        case LinkType.ADMIN:
          return urls.folderAdmin(element.contentId);
        case LinkType.VIEW:
          return urls.folder(element.contentId);
      }
    case "ExamSyllabus":
      switch (linkType) {
        case LinkType.EDIT:
          return urls.examAdminEdit(element.contentId);
        case LinkType.ADMIN:
          return urls.examAdmin(element.contentId);
        case LinkType.VIEW:
          return urls.exam(element.contentId);
      }

    case "StudyProgramme":
      switch (linkType) {
        case LinkType.EDIT:
          return urls.studyProgrammeAdminEdit(element.contentId);
        case LinkType.ADMIN:
          return urls.studyProgrammeAdmin(element.contentId);
        case LinkType.VIEW:
          return urls.studyProgramme(element.contentId);
      }
    case "StudyProgrammeElement":
      if (
        element.type === "Folder" ||
        element.type === "SelfAssessmentsContainer"
      ) {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.folderAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.folderAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.folder(element.contentId);
        }
      } else if (element.type === "ExamSyllabus") {
        switch (linkType) {
          case LinkType.EDIT:
            return urls.examAdminEdit(element.contentId);
          case LinkType.ADMIN:
            return urls.examAdmin(element.contentId);
          case LinkType.VIEW:
            return urls.exam(element.contentId);
        }
      } else {
        throw Error("Illegal type inside study programme");
      }
  }
}
